import { render } from "./Search.vue?vue&type=template&id=163c7572&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=163c7572&lang=scss"
import "./Search.vue?vue&type=style&index=1&id=163c7572&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-163c7572"

export default script